module.exports = __webpack_public_path__ + "img/sumka.566ab30b.svg";